import React from 'react';
import { NavbarBrand } from 'reactstrap';

import config from '../../config/app';

const LOGO_URLS = {
  DEFAULT: 'https://pd-static-assets.pagerduty.com/logos/main.svg',
  PRIDE: 'https://pd-static-assets.pagerduty.com/logos/pride/logo.svg',
  VOTE: `https://pd-static-assets.pagerduty.com/logos/vote/logo.gif?cachebuster=${new Date().getTime()}`
};

export default () => (
  <NavbarBrand
    style={{ backgroundImage: `url(${LOGO_URLS[config.LOGO_TYPE] || LOGO_URLS.DEFAULT})` }}
    href="/"
  >
    PagerDuty
  </NavbarBrand>
);
